import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import ReactPlayer from 'react-player/youtube';
import { Circles } from 'react-loader-spinner';
import debounce from 'lodash.debounce';
import { Helmet } from 'react-helmet';

const local = "https://localhost:44351/api/home/goLiveStreame"
const online = "https://api.shabdtoday.com/api/home/goLiveStreame"

const LiveUrl = () => {
  const [liveStreamUrl, setLiveStreamUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMiniPlayer, setIsMiniPlayer] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const videoRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(online);
        if (response.data && response.data.liveStreame && response.data.liveStreame.length > 0) {
          const url = response.data.liveStreame[0].streameUrl;
          const urlWithParams = url.includes('?') ? `${url}&autoplay=1&mute=1` : `${url}?autoplay=1&mute=1`;
          setLiveStreamUrl(urlWithParams);
        } else {
          setError('No live stream URL available');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    const handleScroll = debounce(() => {
      if (videoRef.current) {
        const rect = videoRef.current.getBoundingClientRect();
        const currentScrollY = window.scrollY;

        // Show mini player only when scrolling down
        if (currentScrollY > lastScrollY && rect.top <= 0 && !isMiniPlayer) {
          setIsMiniPlayer(true);
        } else if (currentScrollY < lastScrollY && isMiniPlayer && rect.top > 0) {
          setIsMiniPlayer(false);
        }

        setLastScrollY(currentScrollY);
      }
    }, 100); // Debounce delay of 100ms

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMiniPlayer, lastScrollY]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Circles
          height="30"
          width="30"
          color="#f7265c"
          ariaLabel="circles-loading"
          visible={true}
        />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <Helmet>
        <title>लाइव न्यूज़ | आज की ताज़ा ब्रेकिंग खबरें हिंदी में लाइव अपडेट | ShabdToday</title>
        <link rel="canonical" href="https://shabdtoday.com/Live-News" />
        <meta name="viewport" content="width=device-width,minimum-scale=1,initial-scale=1" />
        <meta name="title" content="लाइव न्यूज़ – आज की ताज़ा ब्रेकिंग खबरें हिंदी में | ShabdToday" />
        <meta name="description" content="देश-दुनिया की सभी बड़ी ब्रेकिंग और लाइव खबरें हिंदी में मिनट-टू-मिनट अपडेट के साथ। राजनीति, खेल, मौसम, मनोरंजन और क्राइम की लेटेस्ट लाइव न्यूज़ केवल ShabdToday पर।" />
        <meta name="keywords" content="लाइव न्यूज़, ब्रेकिंग न्यूज़ आज की ताज़ा खबर लाइव, live news hindi, breaking news live, लाइव अपडेट हिंदी में, आज की ताज़ा खबर लाइव" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ShabdToday News" />

        <meta property="og:title" content="लाइव न्यूज़ | आज की ब्रेकिंग खबरें हिंदी में लाइव | ShabdToday" />
        <meta property="og:description" content="मिनट-टू-मिनट लाइव अपडेट – देश-दुनिया की सभी बड़ी ब्रेकिंग खबरें हिंदी में सबसे तेज़।" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://shabdtoday.com/Live-News" />
        <meta property="og:image" content="https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp" />
        <meta property="og:image:alt" content="ShabdToday लाइव न्यूज़" />
        <meta property="og:site_name" content="ShabdToday" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": "https://shabdtoday.com/Live-News#webpage",
            "url": "https://shabdtoday.com/Live-News",
            "name": "लाइव न्यूज़ – आज की ताज़ा ब्रेकिंग खबरें हिंदी में",
            "headline": "लाइव न्यूज़ | मिनट-टू-मिनट अपडेट",
            "description": "देश-दुनिया की सभी बड़ी ब्रेकिंग और लाइव खबरें हिंदी में मिनट-टू-मिनट अपडेट के साथ।",
            "image": "https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp",
            "inLanguage": "hi-IN",
            "isPartOf": {
              "@type": "WebSite",
              "@id": "https://shabdtoday.com/#website",
              "url": "https://shabdtoday.com/",
              "name": "Shabd Today",
              "publisher": {
                "@type": "Organization",
                "name": "Shabd Today",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://shabdtoday.com/design/images/logo-s.webp"
                }
              }
            }
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://shabdtoday.com/Live-News"
            },
            "url": "https://shabdtoday.com/Live-News",
            "headline": "लाइव न्यूज़ – आज की सभी बड़ी ब्रेकिंग खबरें हिंदी में",
            "description": "मिनट-टू-मिनट लाइव अपडेट – राजनीति, खेल, मौसम, क्राइम और मनोरंजन की ताज़ा ब्रेकिंग न्यूज़।",
            "image": "https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp",
            "datePublished": new Date().toISOString().split('T')[0],
            "dateModified": new Date().toISOString(),
            "author": { "@type": "Organization", "name": "Shabd Today" },
            "publisher": {
              "@type": "Organization",
              "name": "Shabd Today",
              "logo": {
                "@type": "ImageObject",
                "url": "https://shabdtoday.com/design/images/logo-s.webp"
              }
            },
            "inLanguage": "hi-IN"
          })}
        </script>
      </Helmet>
      {isMiniPlayer && (
        <button className='MobileYoutube'
          onClick={() => setIsMiniPlayer(false)}
          style={{
            position: 'fixed',
            top: 395,
            right: 10,
            zIndex: 1000,
            backgroundColor: 'red',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '5px 10px',
            display: 'block', // Ensure the button does not leave a space
          }}
        >
          Close
        </button>
      )}
      <div
        ref={videoRef}
        className={`live-video-container ${isMiniPlayer ? 'mini' : ''}`}
        style={{
          textAlign: 'center',
          position: isMiniPlayer ? 'fixed' : 'relative',
          bottom: isMiniPlayer ? '10px' : 'auto',
          right: isMiniPlayer ? '10px' : 'auto',
          width: isMiniPlayer ? '300px' : '100%',
          height: isMiniPlayer ? '170px' : 'auto',
          zIndex: isMiniPlayer ? 1000 : 'auto',
          border: isMiniPlayer ? '1px solid #ccc' : 'none',
          transition: 'all 0.3s ease-in-out', // Smooth transition
          overflow: 'hidden', // Ensure no overflow
        }}
      >
        {liveStreamUrl ? (
          <ReactPlayer
            url={liveStreamUrl}
            controls
            width="100%"
            height="100%"
            playing={true}
            muted={false}
          />
        ) : (
          <div>No live stream available</div>
        )}
      </div>
    </div>
  );
};

export default LiveUrl;
